import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/style/style.css';
import keepaiLogo from '../resource/keepaiLogo.png';

const Main = () => {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const [activeCategory, setActiveCategory] = useState('all');
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);

    const stored = localStorage.getItem('user');
    const isLoggedIn = !!stored;
    const userName = stored ? JSON.parse(stored).name : null;
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleLogout = () => {
        localStorage.removeItem('user');
        setDropdownOpen(false);
        navigate('/login');
    };

    // 카테고리 목록
    const categories = [
        { id: 'all', name: '전체', icon: '▦' },
        { id: 'chatbot', name: 'AI 챗봇', icon: '💬' },
        { id: 'image', name: '이미지 생성', icon: '🖼' },
        { id: 'video', name: '영상 생성', icon: '🎬' },
        { id: 'audio', name: '음성 / 음악', icon: '🎵' },
        { id: 'writing', name: '글쓰기', icon: '✏️' },
        { id: 'productivity', name: '생산성', icon: '📊' },
        { id: 'dev', name: '개발', icon: '</>' },
        { id: 'design', name: '디자인', icon: '🎨' },
        { id: 'marketing', name: '마케팅', icon: '📢' },
        { id: 'etc', name: '기타', icon: '⋯' },
    ];

    // 인기 검색어
    const popularKeywords = ['ChatGPT', 'Midjourney', 'Claude', 'Notion AI', 'Runway', 'Perplexity', 'Gamma', 'Copilot'];

    // 임시 데이터 (실제로는 API에서 받아옴)
    const mockServices = [
        {
            id: 1, name: 'ChatGPT Plus', provider: 'OpenAI', category: 'chatbot',
            price: 19000,
            description: '더 똑똑해진 AI와 대화하고\n생산성을 높여보세요.',
            logo: '🤖', logoColor: '#10A37F'
        }
    ];

    useEffect(() => {
        const filtered = activeCategory === 'all'
            ? mockServices
            : mockServices.filter(s => s.category === activeCategory);
        setServices(filtered);
        setLoading(false);
    }, [activeCategory]); // eslint-disable-line

    const handleSearch = () => {
        if (!query.trim()) return;
        navigate('/chat', { state: { query: query.trim() } });
    };

    const handleKeywordClick = (keyword) => {
        navigate('/chat', { state: { query: keyword } });
    };

    return (
        <div className="keepai-wrapper">
            {/* 헤더 */}
            <header className="keepai-header">
                <div className="header-inner">
                    <div className="logo">
                        <img src={keepaiLogo} alt={keepaiLogo}/>
                    </div>
                    <nav className="nav-menu">
                        <button className="nav-item active" onClick={() => navigate('/')}>AI 검색</button>
                    </nav>
                    <div className="header-actions">
                        {isLoggedIn ? (
                            <div className="user-menu">
                                <button className="btn-user" onClick={() => setDropdownOpen(v => !v)}>
                                    {userName}님 ▾
                                </button>
                                {dropdownOpen && (
                                    <>
                                        <div className="user-dropdown-backdrop" onClick={() => setDropdownOpen(false)} />
                                        <div className="user-dropdown">
                                            <button onClick={handleLogout}>로그아웃</button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <>
                                <button className="btn-login" onClick={() => navigate('/login')}>로그인</button>
                                <button className="btn-signup" onClick={() => navigate('/login', { state: { tab: 'register' } })}>회원가입</button>
                            </>
                        )}
                    </div>
                </div>
            </header>

            {/* 히어로 섹션 */}
            <section className="hero-section">
                <div className="hero-icons">
                    <div className="floating-icon icon-1">🤖</div>
                    <div className="floating-icon icon-2">🎨</div>
                    <div className="floating-icon icon-3">AI</div>
                    <div className="floating-icon icon-4">◆</div>
                </div>

                <h1 className="hero-title">
                    AI를 더 <span className="highlight-blue">스마트하게</span>,<br/>
                    구독은 더 <span className="highlight-purple">저렴하게</span>.
                </h1>
                <p className="hero-subtitle">
                    Keep AI에서 다양한 AI 서비스를 할인된 가격으로 만나보세요.
                </p>

                {/* 검색바 */}
                <div className="search-bar">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        placeholder="원하는 AI 서비스를 검색해보세요 (예: ChatGPT, Midjourney)"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                    <button className="search-btn" onClick={handleSearch}>검색</button>
                </div>

                {/* 인기 검색어 */}
                <div className="popular-keywords">
                    <span className="popular-label">인기 검색어</span>
                    {popularKeywords.map((kw, idx) => (
                        <button
                            key={idx}
                            className="keyword-chip"
                            onClick={() => handleKeywordClick(kw)}
                        >
                            {kw}
                        </button>
                    ))}
                </div>
            </section>

            {/* 카테고리 탭 */}
            <section className="category-section">
                <div className="category-tabs">
                    {categories.map(cat => (
                        <button
                            key={cat.id}
                            className={`category-tab ${activeCategory === cat.id ? 'active' : ''}`}
                            onClick={() => setActiveCategory(cat.id)}
                        >
                            <span className="cat-icon">{cat.icon}</span>
                            <span className="cat-name">{cat.name}</span>
                        </button>
                    ))}
                </div>
            </section>

            {/* 인기 AI 서비스 */}
            <section className="services-section">
                <div className="section-header">
                    <h2>🔥 인기 AI 서비스</h2>
                </div>

                <div className="services-grid">
                    {loading ? (
                        <div className="loading">로딩 중...</div>
                    ) : (
                        services.map(service => (
                            <div
                                key={service.id}
                                className="service-card"
                                onClick={() => { if (!isLoggedIn) navigate('/login', { state: { tab: 'register' } }); }}
                                style={{ cursor: isLoggedIn ? 'default' : 'pointer' }}
                            >
                                <button className="favorite-btn" onClick={(e) => { e.stopPropagation(); if (!isLoggedIn) navigate('/login', { state: { tab: 'register' } }); }}>♡</button>

                                <div className="service-header">
                                    <div
                                        className="service-logo"
                                        style={{ backgroundColor: service.logoColor + '20', color: service.logoColor }}
                                    >
                                        {service.logo}
                                    </div>
                                    <div className="service-info">
                                        <h3>{service.name}</h3>
                                        <p className="provider">{service.provider}</p>
                                    </div>
                                </div>

                                <p className="service-desc">
                                    {service.description.split('\n').map((line, i) => (
                                        <React.Fragment key={i}>{line}<br/></React.Fragment>
                                    ))}
                                </p>

                                <div className="price-row">
                                    <span className="sale-price">월 {service.price.toLocaleString()}원</span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </section>

            {/* 하단 혜택 배너 */}
            <section className="benefits-section">
                <div className="benefit-item">
                    <span className="benefit-icon">🏷</span>
                    <div>
                        <h4>최대 20% 할인</h4>
                        <p>다양한 AI 서비스를<br/>더 저렴한 가격으로</p>
                    </div>
                </div>
                <div className="benefit-item">
                    <span className="benefit-icon">🛡</span>
                    <div>
                        <h4>안전한 결제</h4>
                        <p>검증된 결제 시스템으로<br/>안심하고 이용하세요</p>
                    </div>
                </div>
                <div className="benefit-item">
                    <span className="benefit-icon">🎧</span>
                    <div>
                        <h4>고객 지원</h4>
                        <p>문제 해결을 위한<br/>전문 지원을 제공합니다</p>
                    </div>
                </div>
                <div className="benefit-item">
                    <span className="benefit-icon">🔄</span>
                    <div>
                        <h4>간편한 구독 관리</h4>
                        <p>구독 현황을 한눈에<br/>쉽게 관리하세요</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Main;
